// Story 12.4 — QR query for the connection modal. Refreshes the QR every
// 30s because Evolution invalidates QR tokens after ~20-30s. Disabled by
// default; the modal enables it only when its open + status is not linked.

import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api-client';

/** Story 17-2 — sin `kind`, una API anterior: es un QR. */
export type EvolutionQrResponse =
  | {
      kind?: 'qr';
      /** Base64 del PNG; Evolution GO v0.7 lo manda como data URL completa. */
      qrImageBase64: string;
      qrText: string;
    }
  | { kind: 'passkey'; stage: string };

/** Mientras Evolution GO arranca el cliente, la API responde 409 QR_NOT_READY. */
const QR_NOT_READY_RETRIES = 10;

export function isQrNotReady(err: unknown): boolean {
  return err instanceof ApiError && err.code === 'QR_NOT_READY';
}

export function qrImageSrc(qrImageBase64: string): string {
  return qrImageBase64.startsWith('data:')
    ? qrImageBase64
    : `data:image/png;base64,${qrImageBase64}`;
}

export function useEvolutionQr(botId: number, opts: { enabled: boolean }) {
  return useQuery({
    queryKey: ['bots', botId, 'evolution-qr'] as const,
    queryFn: () => api.get<EvolutionQrResponse>(`/api/v1/bots/${botId}/whatsapp/qr`),
    refetchInterval: 30_000,
    enabled: opts.enabled && Number.isFinite(botId),
    // Solo se reintenta "todavía no hay QR"; un 404 (ya vinculado) o un 502
    // (falló, licencia incluida) se muestran de una.
    retry: (failureCount, err) => isQrNotReady(err) && failureCount < QR_NOT_READY_RETRIES,
    retryDelay: 2000,
  });
}
